import React from 'react';
import NavBarItem from './NavBarItem';
import './NavBar.css';

const NavBar = () => {
  return (
    <nav id="mainNav" className="navbar navbar-expand-lg navbar-light fixed-top">
      <div className="container">
        <a className="navbar-brand js-scroll-trigger" href="#root">
          Motion AR
        </a>
        <button
          className="navbar-toggler navbar-toggler-right"
          type="button"
          data-toggle="collapse"
          data-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          Menu <i className="fas fa-bars" />
        </button>
        <div className="collapse navbar-collapse" id="navbarResponsive">
          <ul className="navbar-nav ml-auto">
            <NavBarItem title="About" />
            <NavBarItem title="Demos" />
            <NavBarItem title="Team" />
            <NavBarItem title="Contact" />
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
